window.Vivense = window.Vivense || {};

Vivense.stringUtil = (function ($) {

    var exports = {};


    function capitalizeString(str) {
        str.keyup(function () {
            var name = str.val();
            var lowerName = toLowerCase(name,false)
            var titleName = toTitleCase(lowerName);
            str.val(titleName);
        });

        function toTitleCase(str) {
            return str.replace(/(?:^|\s)[a-zA-Züşöç]/g, function (match) {
                return toUpperCase(match);
            });
        }
    }

    function removeNumbersFromElement(element) {
        element.keyup(function () {
            var formattedName = $(this).val().replace(/\d+/g, "");
            $(this).val(formattedName);
        });
    }

    function toLowerCase(string, removeTrChars) {
        var letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
        string = string.replace(/[İIŞĞÜÇÖ]/g, function (letter) {
            return letters[letter];
        })

        var formattedString = string.toLowerCase();

        if (removeTrChars){
            return removeTurkishChars(formattedString)
        }

        return formattedString;
    }

    function toUpperCase(string) {
        var letters = {"i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I"};
        string = string.replace(/(([iışğüçö]))/g, function (letter) {
            return letters[letter];
        })
        return string.toUpperCase();
    }

    function removeTurkishChars(string){
        var letters = {"İ": "", "I": "", "Ş": "", "Ğ": "", "Ü": "", "Ö": "", "Ç": "",
            "ı": "ı", "ş": "", "ğ": "", "ü": "", "ö": "", "ç": ""};
        string = string.replace(/[İIıŞşĞğÜüÇçÖö]/g, function (letter) {
            return letters[letter];
        })
        return string.toLowerCase();
    }

    exports.capitalizeString = capitalizeString;
    exports.removeNumbersFromElement = removeNumbersFromElement;
    exports.toLowerCase = toLowerCase;

    return exports;
})(jQuery);
